import { derivePalette, deriveTokens, type ThemeRecipe } from '../recipe';
import type { Theme } from '../types';

// Talvi — winter. First v2 preset built entirely through the recipe
// path: tokens come from deriveTokens(), palette from derivePalette(),
// decoration is a serializable DecorationSpec rendered by
// <DecorationLayer>. Validates that the recipe path produces a
// credible-looking theme (tasks/v2-themes.md §D2 acceptance).
const recipe: ThemeRecipe = {
  base: '#7dd3fc', // sky-blue 300
  secondary: '#bae6fd', // sky-blue 200
  tertiary: '#f0f9ff', // sky-blue 50 — near-white horizon
  mood: 'soft',
};

export const talviTheme: Theme = {
  key: 'talvi',
  name: 'Talvi',
  tokens: deriveTokens(recipe),
  decoration: {
    kind: 'spec',
    spec: {
      sprite: 'snow',
      motion: 'fall',
      density: 'high',
      speed: 'slow',
    },
  },
  routineCardPalette: derivePalette(recipe),
};
